import { render, staticRenderFns } from "./_EditRecycleDisposalReportDialog.vue?vue&type=template&id=56b35c78&scoped=true&"
import script from "./_EditRecycleDisposalReportDialog.vue?vue&type=script&lang=js&"
export * from "./_EditRecycleDisposalReportDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b35c78",
  null
  
)

export default component.exports